import { defineCapability } from './internal';
import { args } from '../common/args';

export const RESTYLE_CAP = defineCapability({
  name: 'RESTYLE_CAP' as const,
  args: {
    style: args.cssProperties(),
    merge: args.bool(),
  },
});
